import { connect } from 'react-redux';

import RelatedProducts from './relatedProducts';
import { getRelatedProductsStatus, getRelatedProductsData } from './store/selectors';
import { getItemCommentsData, getItemCommentsStatus } from '../storeHome/store/selectors';
import { getOrderBuilderData, getCartData } from '../orderBuilder/store/selectors';
import { loadRelatedProducts } from './store/action-creators';
import { loadItemComments } from '../storeHome/store/action-creators';
import { addOrderToCart } from '../orderBuilder/store/action-creators';

const mapStateToProps = (state) => ({
  relatedProductsStatus: getRelatedProductsStatus(state),
  relatedProductsData: getRelatedProductsData(state),
  itemCommentsStatus: getItemCommentsStatus(state),
  itemCommentsData: getItemCommentsData(state),
  allProductsData: getOrderBuilderData(state),
  cartData: getCartData(state),
});

const mapDispatchToProps = {
  loadRelatedProducts,
  loadItemComments,
  addOrderToCart,
}

export default connect(mapStateToProps, mapDispatchToProps)(RelatedProducts);